module.exports = __webpack_public_path__ + "img/cach-icon.40f7ff58.svg";